import { RuleAudienceIcon } from '@/lib/Icons';
import { ExpressionCondition } from '@/models/audiences';
import { ISelectItem } from '@/models/select';
import { first } from 'lodash';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AudienceSelect, SearchDropdown } from '../selects';

type MembershipConditionProps = {
  expression: ExpressionCondition;
  onChange?: (condition: ExpressionCondition) => void;
  isViewMode?: boolean;
};

export const MembershipCondition: FC<MembershipConditionProps> = ({ expression, isViewMode, onChange }) => {
  const { t } = useTranslation();

  const membershipOps: (ISelectItem & { displayName: string })[] = [
    {
      id: 0,
      label: t('audience_edit:rules.belongs_to'),
      displayName: t('audience_edit:rules.belongs_to'),
    },
    {
      id: 1,
      label: t('audience_edit:rules.not_belongs_to'),
      displayName: t('audience_edit:rules.not_belongs_to'),
    },
  ];

  const [searchQuery, setSearchQuery] = useState('');

  if (isViewMode) {
    // Compact view mode layout
    return (
      <div className='flex flex-wrap items-center gap-2 text-sm'>
        <span className='flex items-center gap-2'>
          <RuleAudienceIcon className='size-4 text-brand-600' />
          <span>{expression.membership === 'IN' ? t('audience:rules.belongs_to') : t('audience:rules.not_belongs_to')}</span>
        </span>
        <AudienceSelect
          audienceId={first(expression.audienceIds)}
          onChange={() => {}}
          isViewMode={true}
          className='rounded-md border border-quaternary-200 px-2 py-1 font-medium'
        />
      </div>
    );
  }

  return (
    <div className='flex w-full'>
      <div className={'mx-2 inline-flex w-[180px] items-center text-sm'}>
        <span className={'flex items-center gap-2'}>
          <RuleAudienceIcon className={'inline-block size-6 text-brand-600'} />
          <span className='text-sm text-primary-900'>{t('audience_edit:partOfAnAudience_read')}</span>
        </span>
      </div>
      <div className='mx-2'>
        {isViewMode ? (
          <p>{expression.membership === 'IN' ? t('audience:rules.belongs_to') : t('audience:rules.not_belongs_to')}</p>
        ) : (
          <SearchDropdown
            items={
              searchQuery?.trim() ? membershipOps.filter((item) => item.displayName.toLowerCase().includes(searchQuery?.trim().toLowerCase())) : membershipOps
            }
            item={expression.membership && (expression.membership === 'IN' ? membershipOps[0] : membershipOps[1])}
            placeholder={t('audience_edit:rules.belongs_to') as string}
            setItem={(opItemValue) => {
              onChange?.({
                ...expression,
                membership: opItemValue.id === 0 ? 'IN' : 'NOT_IN',
              });
            }}
            setQuery={setSearchQuery}
            loading={false}
            readOnly={isViewMode}
            openWithFocus={true}
            className={`border px-2 py-1 `}
          >
            {(item) => <div className={'whitespace-nowrap'}>{item.displayName}</div>}
          </SearchDropdown>
        )}
      </div>
      <div className='mx-2'>
        <AudienceSelect
          audienceId={first(expression.audienceIds)}
          onChange={(audienceItemValue) => {
            onChange?.({
              ...expression,
              audienceIds: [String(audienceItemValue.id)],
            });
          }}
          isViewMode={isViewMode}
        />
      </div>
    </div>
  );
};
